import { render, staticRenderFns } from "./finishtutorial.vue?vue&type=template&id=195658d8&scoped=true&"
import script from "./finishtutorial.vue?vue&type=script&lang=js&"
export * from "./finishtutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195658d8",
  null
  
)

export default component.exports